import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { HeadingWidgetService } from '../../../heading-widget/service/heading-widget.service';
import { iif, Observable, of } from 'rxjs';
import { delay, filter, map, mergeMap, tap } from 'rxjs/operators';
import { SummaryModel } from '../../model/summary.model';
import { MaterialModule } from 'src/app/shared/module/material.module';
import { CommonModule } from '@angular/common';
import { I18nPipe } from 'src/app/shared/i18n/pipe/i18n.pipe';

@Component({
  selector: '[ald-summary-auto-complete]',
  templateUrl: './summary-auto-complete.component.html',
  styleUrls: ['./summary-auto-complete.component.scss'],
  exportAs: 'ald-summary-auto-complete',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MaterialModule,
    CommonModule,
    I18nPipe
  ]
})
export class SummaryAutoCompleteComponent implements OnInit {

  public fgParent: UntypedFormGroup = new UntypedFormGroup({});
  @Input() summary: SummaryModel;
  @Input() formSubmitted: boolean;
  @Input() isInWebForm: boolean;
  @Input() focusOutAction: boolean;
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() focusOutAutocomplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  filteredOptions: Observable<string[]>;

  constructor(
    private parentGroup: ControlContainer,
    private headingWidgetService: HeadingWidgetService
  ) { }

  ngOnInit(): void {
    this.fgParent = this.parentGroup.control instanceof UntypedFormGroup ? this.parentGroup.control : new UntypedFormGroup({});
    
    this.fgParent.addControl(this.summary.techname, new UntypedFormControl(
      !!this.summary.value ? this.summary.value : '', 
      this.summary.validators !== undefined ? this.summary.validators : []
    ));

    this.filteredOptions = this.fgParent.get(this.summary.techname).valueChanges.pipe(
      map(value => this._filter(value || '')),
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value?.toLowerCase();
    let listToReturn = this.summary.child.filter(option => option.label?.toLowerCase()?.includes(filterValue))
    if(listToReturn.length > 0){
      return listToReturn;
    }
    this.fgParent.get(this.summary.techname).setValue('');
    return listToReturn;
  }

  getLabelTranslation(label): string {
		return this.headingWidgetService.camelToUnderscore(label)
	}

  closeAutoComplete(event){
    const selectedValue = event.option.value;
    this.fgParent.get(this.summary.techname).setValue(selectedValue, { emitEvent: false });
    this.selectionChange.emit(selectedValue);
  }

  focusOut(){
    of(null).pipe(
      delay(120),
      map(()=> {
        let findElement = this.summary.child.find((f) => f.value === this.fgParent.get(this.summary.techname).value);
        this.focusOutAutocomplete.emit(true);
        return findElement;
      }),
      mergeMap((findElement) => 
        iif(() => !!findElement,
          of(null).pipe(
            filter(() => (this.fgParent.get(this.summary.techname).value === '' || this.fgParent.get(this.summary.techname).value === null) && 
              this.summary.value !== undefined && this.fgParent.get(this.summary.techname).value !== this.summary.value),
            tap(() => {
              this.fgParent.get(this.summary.techname).setValue('');
              this.selectionChange.emit(undefined);
            })
          ),
          of(null).pipe(
            tap(() => {
              this.fgParent.get(this.summary.techname).setValue('');
              this.selectionChange.emit(undefined);
            })
          )
        ))
    ).subscribe();
  }

  openDrowDown(trigger){
    if(this.fgParent.get(this.summary.techname).value === '' || this.fgParent.get(this.summary.techname).value === null){
      this.fgParent.get(this.summary.techname).setValue('');
      setTimeout(() => {
        trigger.openPanel();
      }, 100);
    }
  }

  getClassInvalid(): boolean{
    if(this.isInWebForm && ((this.formSubmitted || this.focusOutAction) && this.fgParent.get(this.summary?.techname).status === 'INVALID') || 
      (this.fgParent.get(this.summary?.techname).status === 'INVALID' && this.fgParent.get(this.summary?.techname)?.touched)){
      return true;
    } 
    return false;
  }
}
